import { Button, DropZone, DropZoneProps } from '@shopify/polaris';
import { CameraIcon, EditIcon } from '@shopify/polaris-icons';
import useMainStore from '../store/useMainStore';
import { useShallow } from 'zustand/shallow';
import { useNavigate } from 'react-router-dom';

const MediaCapture = () => {
    const router = useNavigate();
    const { setCurrentImage } = useMainStore(
        useShallow((state) => ({
            setCurrentImage: state.setCurrentImage,
        })),
    );

    const handleDrop: NonNullable<DropZoneProps['onDrop']> = (_dropFiles, acceptedFiles) => {
        setCurrentImage(acceptedFiles?.[0], 'upload');
        router('/stores');
    };

    const handleSignatureCapture = () => {
        router('/signature');
    };

    return (
        <div className="h-dvh flex flex-col items-center justify-center gap-4">
            <DropZone onDrop={handleDrop} type="image" allowMultiple={false} accept="image/png,image/jpeg,image/jpg">
                <div className="p-8">
                    <Button size="large" icon={CameraIcon}>
                        Upload Image
                    </Button>
                </div>
            </DropZone>

            <Button size="large" icon={EditIcon} onClick={handleSignatureCapture}>
                Capture Signature
            </Button>
        </div>
    );
};

export default MediaCapture;
